<script setup>
import { computed } from 'vue'
import AsideMenuItem from '@/components/AsideMenuItem.vue'

const props = defineProps({
  isSubmenuList: {
    type: Boolean,
    default: false
  },
  isCollapsed: {
    type: Boolean,
    default: false
  },
  menu: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['menu-click'])

/* Nested lists get an indent plus a guide rail so the hierarchy is visible.
   Not while collapsed: the rail is only wide enough for a centred icon, so a
   `ml-6` indent would push the child icons out of it and misalign them against
   every other row. Collapsed children are distinguished by being smaller and
   directly beneath their parent instead. */
const listClass = computed(() => {
  if (!props.isSubmenuList) return 'space-y-0.5'
  return props.isCollapsed
    ? 'py-0.5 space-y-0.5'
    : 'ml-6 pl-1 py-0.5 space-y-0.5 border-l border-gray-200 dark:border-gray-700'
})

const menuClick = (event, item) => {
  emit('menu-click', event, item)
}
</script>

<template>
  <ul :class="listClass">
    <aside-menu-item
      v-for="(item, index) in menu"
      :key="index"
      :item="item"
      :is-submenu-list="isSubmenuList"
      :is-collapsed="isCollapsed"
      @menu-click="menuClick"
    />
  </ul>
</template>
